import type { AudioInputDevice } from 'amazon-chime-sdk-js';
import type { FC, PropsWithChildren } from 'react';
import { AudioInputProvider, useAudioInputs } from './AudioInputProvider';
import { AudioOutputProvider, useAudioOutputs } from './AudioOutputProvider';
import { VideoInputProvider, useVideoInputs } from './VideoInputProvider';

interface Props {
  onDeviceReplacement?: (
    nextDevice: string,
    currentDevice?: AudioInputDevice,
  ) => Promise<AudioInputDevice>;
}

export const DevicesProvider: FC<PropsWithChildren<Props>> = ({
  children,
  onDeviceReplacement,
}) => (
  <AudioInputProvider onDeviceReplacement={onDeviceReplacement}>
    <AudioOutputProvider>
      <VideoInputProvider>{children}</VideoInputProvider>
    </AudioOutputProvider>
  </AudioInputProvider>
);

export { useAudioInputs, useAudioOutputs, useVideoInputs };
